export const DEFAULT = 'default';
export const LOADING = 'loading';
export const ERROR = 'error';
export const COMPLETED = 'completed';
export const FORM_VALIDATED = 'completed';
